import { Directive, HostListener, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[brlCurrencyMask]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BrlCurrencyMaskDirective),
    multi: true
  }],
  standalone: false
})
export class BrlCurrencyMaskDirective implements ControlValueAccessor {
  private onTouched: () => void = () => {};
  private onChange: (_: any) => void = () => {};
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    let rawValue = this.el.value;

    rawValue = rawValue.replace(/\D/g, '');

    if (rawValue.length === 0) {
      this.el.value = '';
      this.onChange(null);
      return;
    }

    const numericValue = parseFloat(rawValue) / 100;

    const formatted = numericValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });

    this.el.value = formatted;
    this.onChange(numericValue);
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value == null || isNaN(value)) {
      this.el.value = '';
    } else {
      this.el.value = Number(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.el.disabled = isDisabled;
  }
}
